import * as React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@material-ui/core/styles";
import Checkbox from "@material-ui/core/Checkbox";
import TLabel from "./TLabel";
import ListItem from "@material-ui/core/ListItem";

class TCheckBoxLabel extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        caption: PropTypes.string,
        value: PropTypes.bool,
        name: PropTypes.string,
        enabled: PropTypes.bool,
        color: PropTypes.string,
        labelStyle: PropTypes.object,
        onClick: PropTypes.func,
        style: PropTypes.object,
        classes: PropTypes.object,
        info: PropTypes.arrayOf(PropTypes.any),
        onLabelClick: PropTypes.func,
        checkBoxStyle: PropTypes.object,
        listItemStyle: PropTypes.object,
    };

    static defaultProps = {
        caption: "",
        value: null,
        name: "",
        enabled: true,
        color: "primary",
        labelStyle: {},
        onClick: (checked) => console.log("TCheckBox onClick [" + checked + "]"),
        style: {},
        classes: {},
        info: [],
        onLabelClick: () => console.log("onLabelClick"),
        checkBoxStyle: {},
        listItemStyle: {},
    };

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if (JSON.stringify(this.props) !== JSON.stringify(nextProps)) {
            return true;
        } else {
            return false;
        }
    }

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onCheckboxChange = (event) => {
        this.props.onClick(event.target.checked, event, this.props.name, this.props.caption, this.props.info);
    };

    onLabelClick = (event, checked) => {
        this.props.onLabelClick();
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        const styles = {
            listItem: {
                padding: "2px 0",
            },
            checkbox: {
                height: "30px",
            },
        };

        const unstyledComponent = (props) => (
            <ListItem style={{ ...styles.listItem, ...this.props.listItemStyle }}>
                <Checkbox
                    checked={this.props.value}
                    style={{ ...styles.checkbox, ...this.props.checkBoxStyle }}
                    color={this.props.color}
                    disabled={!this.props.enabled}
                    onClick={this.onCheckboxChange}
                />
                <TLabel
                    caption={this.props.caption}
                    style={{ padding: 0, ...this.props.labelStyle }}
                    onClick={this.onLabelClick}
                />
            </ListItem>
        );

        const StyledComponent = withStyles({
            label: this.props.labelStyle || {},
        })(unstyledComponent);

        return <StyledComponent />;
    }
}

export default TCheckBoxLabel;
